(() => {
  const init = root => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('[data-feedback-form]');
    if (!form) return;
    const steps = [...form.querySelectorAll('[data-stage]')];
    if (!steps.length) return;
    const links = [...root.querySelectorAll('[data-step-jump]')];
    const next = form.querySelector('[data-next]');
    const back = form.querySelector('[data-back]');
    const submit = form.querySelector('[data-submit]');
    const config = JSON.parse(root.querySelector('[data-feedback-config]').textContent);
    let mode = 'After use';
    let active = 0;
    let visited = 0;
    form.noValidate = true;

    const getQuestion = id => form.querySelector(`[data-question="${id}"]`);
    const answer = group => {
      if (!group) return '';
      const inputs = [...group.querySelectorAll('[data-answer]')];
      if (inputs[0]?.matches('[type=radio],[type=checkbox]')) return inputs.filter(x => x.checked).map(x => x.value).join(', ');
      return inputs[0]?.value.trim() || '';
    };
    const setError = (group, message) => {
      const error = group.querySelector('[data-error]');
      group.classList.toggle('has-error', Boolean(message));
      if (error) { error.textContent = message; error.hidden = !message; }
      group.querySelectorAll('[data-answer]').forEach(input => input.setAttribute('aria-invalid', String(Boolean(message))));
    };
    const visibleSteps = () => mode === 'Before use' ? [0, 4] : [0, 1, 2, 3, 4];
    const syncConditions = () => {
      const treatments = answer(getQuestion('Q05'));
      const texture = answer(getQuestion('Q02'));
      getQuestion('Q18').hidden = mode === 'Before use' || !/Colored|Bleached/.test(treatments);
      getQuestion('Q19').hidden = mode === 'Before use' || texture === 'Straight';
      getQuestion('Q21').hidden = mode === 'Before use';
      getQuestion('Q22').hidden = mode === 'Before use';
      form.querySelector('[data-before-notes]').hidden = mode !== 'Before use';
      const concerns = getQuestion('Q06');
      const other = concerns.querySelector('[data-other-details]');
      other.hidden = !concerns.querySelector('[data-role=other]').checked;
      const reaction = getQuestion('Q21');
      reaction.querySelector('[data-reaction-details]').hidden = answer(reaction) !== 'Yes';
      reaction.querySelector('[data-safety]').hidden = answer(reaction) !== 'Yes';
      form.querySelector('[data-final-intro]').textContent = mode === 'Before use' ? config.beforeFinal : config.afterFinal;
      steps.forEach(step => {
        const skipStage = !visibleSteps().includes(Number(step.dataset.stage));
        step.querySelectorAll('[data-question]').forEach(group => {
          group.querySelectorAll('input,select,textarea').forEach(input => {
            input.disabled = skipStage || group.hidden;
          });
        });
      });
      concerns.querySelectorAll('[data-answer]').forEach(input => {
        input.disabled = concerns.querySelectorAll('[data-answer]:checked').length >= 3 && !input.checked;
      });
      other.querySelector('input').disabled = other.hidden;
      reaction.querySelector('[data-reaction-details] textarea').disabled = mode === 'Before use' || reaction.querySelector('[data-reaction-details]').hidden;
      form.querySelector('[data-before-note]').disabled = mode !== 'Before use';
    };
    const go = (index, scroll = true) => {
      active = index;
      const flow = visibleSteps();
      const position = flow.indexOf(active);
      steps.forEach((step, i) => { step.hidden = i !== active; });
      links.forEach((link, i) => {
        link.closest('li').hidden = !flow.includes(i);
        link.disabled = flow.indexOf(i) > visited;
        link.classList.toggle('is-complete', flow.indexOf(i) < position);
        if (i === active) link.setAttribute('aria-current', 'step'); else link.removeAttribute('aria-current');
      });
      root.querySelector('[data-progress-copy]').textContent = config.step.replace('{current}', position + 1).replace('{total}', flow.length);
      root.querySelector('[data-progress-value]').textContent = Math.round(((position + 1) / flow.length) * 100) + '%';
      root.querySelector('[data-progress-fill]').style.width = ((position + 1) / flow.length) * 100 + '%';
      const progress = root.querySelector('[role=progressbar]');
      progress.setAttribute('aria-valuenow', Math.round(((position + 1) / flow.length) * 100));
      progress.setAttribute('aria-valuetext', `${position + 1} / ${flow.length}`);
      back.hidden = position === 0;
      form.querySelector('[data-first-tip]').hidden = position !== 0;
      next.hidden = position === flow.length - 1;
      submit.hidden = position !== flow.length - 1;
      syncConditions();
      if (scroll) {
        root.querySelector('[data-survey-card]').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
        const heading = steps[index].querySelector('h2');
        heading.focus({ preventScroll: true });
      }
    };
    const validate = index => {
      let invalid = null;
      for (const group of steps[index].querySelectorAll('[data-question]')) {
        if (group.hidden) continue;
        let error = '';
        const value = answer(group);
        if (group.dataset.required === 'true' && !value) error = config.required;
        const text = group.querySelector('[data-answer]:not([type=radio]):not([type=checkbox])');
        if (text && value && !text.checkValidity()) error = text.type === 'email' ? config.email : config.required;
        if (group.dataset.question === 'Q06') {
          if (group.querySelectorAll('[data-answer]:checked').length > 3) error = config.maxThree;
          const other = group.querySelector('[data-other-details]');
          if (!other.hidden && !other.querySelector('input').value.trim()) error = config.otherRequired;
        }
        if (group.dataset.question === 'Q21') {
          const details = group.querySelector('[data-reaction-details]');
          if (!details.hidden && !details.querySelector('textarea').value.trim()) error = config.reactionRequired;
        }
        setError(group, error);
        if (error && !invalid) invalid = group;
      }
      return invalid;
    };
    const focusInvalid = group => {
      group.scrollIntoView({ behavior: 'smooth', block: 'center' });
      group.querySelector('[data-answer]').focus({ preventScroll: true });
    };
    const serialize = () => {
      const lines = [config.subject, `${config.stageLabel}: ${mode}`, `${config.productLabel}: ${answer(getQuestion('PRODUCT'))}`, ''];
      for (const step of steps) {
        if (!visibleSteps().includes(Number(step.dataset.stage))) continue;
        for (const group of step.querySelectorAll('[data-question]')) {
          if (group.hidden || ['PRODUCT', 'EMAIL'].includes(group.dataset.question)) continue;
          const id = group.dataset.question;
          const title = group.querySelector('.pfs__question-title').childNodes[0].textContent.trim();
          lines.push(`${id}. ${title}`, answer(group) || config.notProvided);
          const note = group.querySelector('[data-answer-note]')?.value.trim();
          if (note) lines.push(`${config.noteLabel}: ${note}`);
          const other = group.querySelector('[data-other-details]:not([hidden]) input')?.value.trim();
          if (other) lines.push(`${config.otherLabel}: ${other}`);
          const reaction = group.querySelector('[data-reaction-details]:not([hidden]) textarea')?.value.trim();
          if (reaction) lines.push(`${config.reactionLabel}: ${reaction}`);
          lines.push('');
        }
      }
      const beforeNote = form.querySelector('[data-before-note]');
      if (mode === 'Before use' && beforeNote.value.trim()) lines.push(`${config.noteLabel}: ${beforeNote.value.trim()}`, '');
      lines.push(`${config.contactPermission}: ${form.querySelector('[data-contact-permission]').checked ? config.yes : config.no}`);
      return lines.join('\n');
    };

    root.querySelectorAll('[data-mode]').forEach(input => input.addEventListener('change', () => {
      mode = input.value;
      form.querySelector('[data-stage-value]').value = mode;
      visited = 0;
      go(0, false);
    }));
    form.addEventListener('change', event => {
      const group = event.target.closest('[data-question]');
      if (group) {
        if (group.dataset.question === 'Q05' && event.target.matches('[data-answer]')) {
          const none = group.querySelector('[data-role=none]');
          if (event.target === none && none.checked) group.querySelectorAll('[data-answer]').forEach(x => { if (x !== none) x.checked = false; });
          if (event.target !== none && event.target.checked) none.checked = false;
        }
        if (group.dataset.question === 'Q06') {
          const boxes = [...group.querySelectorAll('[data-answer]')];
          const count = boxes.filter(x => x.checked).length;
          boxes.forEach(x => { x.disabled = count >= 3 && !x.checked; });
          group.querySelector('[data-selection-count]').textContent = config.selected.replace('{count}', count);
        }
        if (group.dataset.type === 'scale') {
          const status = group.querySelector('[data-rating-status]');
          status.textContent = event.target.value === 'Not applicable' ? config.na : `${event.target.value} / 10`;
        }
        setError(group, '');
      }
      syncConditions();
    });
    form.addEventListener('input', event => {
      const group = event.target.closest('[data-question]');
      if (group?.classList.contains('has-error')) setError(group, '');
    });
    next.addEventListener('click', () => {
      const invalid = validate(active);
      if (invalid) return focusInvalid(invalid);
      const flow = visibleSteps();
      visited = Math.max(visited, flow.indexOf(active) + 1);
      go(flow[flow.indexOf(active) + 1]);
    });
    back.addEventListener('click', () => { const flow = visibleSteps(); go(flow[flow.indexOf(active) - 1]); });
    links.forEach(link => link.addEventListener('click', () => go(Number(link.dataset.stepJump))));
    form.addEventListener('submit', event => {
      for (const index of visibleSteps()) {
        const invalid = validate(index);
        if (invalid) { event.preventDefault(); go(index); focusInvalid(invalid); return; }
      }
      const body = serialize();
      form.querySelector('[data-feedback-body]').value = body;
      if (root.dataset.preview === 'true') {
        event.preventDefault();
        const notice = form.querySelector('[data-preview-result]');
        notice.textContent = config.previewMessage;
        notice.hidden = false;
        root.dispatchEvent(new CustomEvent('palm:feedback-preview', { detail: { body, stage: mode } }));
        return;
      }
    });
    form.addEventListener('keydown', event => {
      if (event.key === 'Enter' && event.target.matches('input[type=text],input[type=email]') && !next.hidden) { event.preventDefault(); next.click(); }
    });
    root.classList.add('is-ready');
    go(0, false);
  };
  const mount = scope => scope.querySelectorAll('[data-palm-feedback]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document)); else mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
